<div class="login-wrapper">
  <mat-card class="login-card">
    <div>
       <!--logo-->
       <mat-card-header>
        <div mat-card-avatar class="text-center" style="margin-top: 16px;">
          <img alt="Logo" src="../../../../../../assets/images/logo_vcontract.png" width="46%">
        </div>
      </mat-card-header>
      <!--chọn ngôn ngữ-->
      <!-- <div class="text-center txt-select-languages" *ngIf="!isShowTimeLine">
        <a (click)="onChangeLanguage('vi')">{{'header.vietnamese' | translate}}</a>
        <a class="english_border_right" (click)="onChangeLanguage('en')">{{'header.english' | translate}}</a>
        <br>
      </div>
      <div class="text-center txt-select-languages" *ngIf="isShowTimeLine">
        <a>{{'header.vietnamese' | translate}}</a>
        <a class="english_border_right">{{'header.english' | translate}}</a>
        <br>
      </div> -->
      <div class="text-center txt-select-languages mt-3">
        <button type="button" class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
          <div>
            <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
            <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
            <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../../assets/images/china.svg" alt="china" width="30" height="20">
            <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../../assets/images/es.svg" alt="spanish" width="30" height="20">
          </div>
          <span class="">{{getCurrentNameLanguage()}}</span>
          <div class="">
              <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
              <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'vi'}">
              <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
              {{'Tiếng Việt' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'en'}">
              <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
              {{'English' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'zh'}">
              <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
              {{'中国人' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'es'}">
              <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
              {{'Español' | translate}}
          </button>
        </mat-menu>
      </div>
       <!--text Thong bao-->
       <div class="vt-text-authen-header text-center">{{'two_authen.two_step_verify' | translate}}</div>
        <!--text message-->
        <div class="vt-text-authen-message text-center">{{'two_authen.note_verify' | translate}}</div>
        <div class="dive"></div>
        <div class="vt-text-authen-message text-left">{{'two_authen.verify_download' | translate}} <span class="color-primary">{{'two_authen.mysign' | translate}}</span></div>
        <div class="vt-text-authen" style="display: flex;">
          <div *ngIf="!selectedCertCloudCa">
            <span class="vt-text-authen-message text-left" style="color: #EC0033;">{{'two_authen.not_account_clouca' | translate}} <span style="text-decoration: underline; color: blue; cursor: pointer;" (click)="changeCert()">{{'two_authen.here' | translate}}</span></span>
          </div>
          <div *ngIf="selectedCertCloudCa">
            <span class="vt-text-authen-message text-left">{{'two_authen.account_clouca' | translate}}</span>
            <p class="vt-text-authen-message text-left">{{maskNumber(selectedCertCloudCa?.cloudCaUserId)}}</p>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center;">
            <mat-icon *ngIf="!isShowTimeLine" style="color: #07756C; cursor: pointer;" matTooltip="{{'two_authen.edit' | translate}}" (click)="changeCert()">
              edit
            </mat-icon>
            <mat-icon *ngIf="isShowTimeLine" style="color: #b5b4b4;">edit
            </mat-icon>
          </div>
        </div>
        <div class="dive"></div>
        <div class="button-container">
          <div class="button-send" (click)="onSendRequest()" *ngIf="!isShowTimeLine && selectedCertCloudCa">
            {{'two_authen.send_require' | translate}}
          </div>
          <div class="button-send-disabled" *ngIf="isShowTimeLine || !selectedCertCloudCa">
            {{'two_authen.send_require' | translate}}
          </div>
        </div>
        <div class="vt-text-authen-message text-left">{{'two_authen.please_access' | translate}} <span class="color-primary">{{'two_authen.mysign' | translate}}</span> {{'two_authen.verify_perform' | translate}}</div>
        <div class="button-container" *ngIf="countdown$ | async as countdown">
          <div class="time-sign" *ngIf="countdown > 0">{{'two_authen.end_time' | translate}} {{ formatTime(countdown) }}</div>
        </div>
      </div>  
  </mat-card>
</div>
